import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { TUTOR_TOKEN, USER_INFO } from '../../constants';

const MagicLinkLogin = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const authenticateWithMagicLink = async () => {
      try {
        setLoading(true);
        setError('');

        // Call the magic link login API
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tutor/magic-login/${token}/`);
        const data = await response.json();

        if (data.success) {
          const { user, token: authToken } = data.data;
          
          // Verify user is a tutor
          if (user.user_type !== 'TUTOR') {
            setError('Invalid magic link - not a tutor account');
            setLoading(false);
            return;
          }
          
          // Save user data in localStorage
          localStorage.setItem(TUTOR_TOKEN, authToken);
          localStorage.setItem(USER_INFO, JSON.stringify(user));
          
          // Login the user
          await login(user, authToken, 'tutor');
          
          // Navigate to dashboard
          navigate('/tutor/dashboard', { replace: true });
        } else {
          setError(data.message || 'Invalid magic link');
        }
      } catch (err) {
        console.error('Magic link authentication error:', err);
        setError('Failed to authenticate with magic link');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      authenticateWithMagicLink();
    } else {
      setError('No magic link token provided');
      setLoading(false);
    }
  }, [token, navigate, login]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
              <span className="ml-3 text-gray-600">Authenticating...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Authentication Failed</h2>
              <p className="text-red-600 mb-4">{error}</p>
              <button
                onClick={() => navigate('/tutor/login')}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Go to Login Page
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default MagicLinkLogin;

